import { render, staticRenderFns } from "./teacherManageEdit.vue?vue&type=template&id=1aa16bcf&scoped=true&"
import script from "./teacherManageEdit.vue?vue&type=script&lang=js&"
export * from "./teacherManageEdit.vue?vue&type=script&lang=js&"
import style0 from "./teacherManageEdit.vue?vue&type=style&index=0&id=1aa16bcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa16bcf",
  null
  
)

export default component.exports